export default {
  MEDIA_ORDER_RETURN_MEDIA_INFO(state, payload) {
    state.returnOrderMediaData = payload;
  },
  ANY_ORDER_INFO(state, payload) {
    state.anyOrderData = payload;
  },
};
